export * from './cliente-saldo-list.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/cliente-saldo-list/index.ts